export default "__VITE_ASSET__D_nw_Cnm__";